import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import Storage from '@/utils/storage'
// locales
import en from 'vuetify/es5/locale/en'
import vi from './vuetifyLocaleVi'
// font https://materialdesignicons.com/
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

// Get from local store
const locale = Storage.get('LOCALE_DEFAULT', 'en') || 'en'
const theme = Storage.get('THEME_DEFAULT', 'light') || 'light'
if (theme === 'dark') {
  window.document.body.classList.add('body-dark')
} else {
  window.document.body.classList.add('body-light')
}

export default new Vuetify({
  theme: {
    icons: {
      iconfont: 'mdi'
    },
    dark: theme === 'dark',
    themes: {
      light: {
        primary: '#4287f5'
        // secondary: '#62728C',
        // tertiary: '#979CA3',
        // error: '#DB3932'
      },
      dark: {
        primary: '#4287f5'
      }
    }
  },
  lang: {
    locales: { en, vi },
    current: locale
  }
})
